<template>
  <CommonDrop
    v-model="currentValue"
    url="/trade/currency/list"
    :autoDefault="false"
    :disabled="disabled"
    valName="name"
    size="mini"
  ></CommonDrop>
</template>
<script>
import CommonDrop from "@/components/CommonDrop";
export default {
  components: { CommonDrop },
  name: "Currency",
  props: {
    value: {
      type: String | Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
      },
    },
  },
  methods: {},
};
</script>
